import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CustomFieldBaseInput } from './custom-field-base-input.directive';
import { CommonModule } from '@angular/common';
import { SharedFormModule } from '@shared/modules/form';
import { CustomFieldType } from '@shared/models';
import { isNumber, isString } from '@hints/utils/types';

@Component({
  selector: 'cwt-custom-field-simple-input',
  template: `
    <nz-form-item>
      <nz-form-label>{{customField.name | cwtDictionary}}</nz-form-label>
      <nz-form-control>
          <input *ngIf="!customField.isMultiSelect" nz-input [disabled]="disabled" [(ngModel)]="value" [type]="customField.type" />
          <nz-select *ngIf="customField.isMultiSelect" [nzDisabled]="disabled" [(ngModel)]="value" nzMode="tags" [nzTokenSeparators]="[',', ';']"></nz-select>
      </nz-form-control>
    </nz-form-item>
  `,
  standalone: true,
  imports: [
    CommonModule,
    SharedFormModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomFieldSimpleInputComponent extends CustomFieldBaseInput<number | string> {
  protected formatValue(v: any): number | string {
    if (this.customField.type === CustomFieldType.Number) {
      if (isNumber(v)) return v;
      return Number(v);
    }

    if (isString(v)) return v;
    return String(v);
  }
}
